import { useEffect, useRef } from 'react';
import { Container } from '@mui/material';
import nexusLogo from '../../asset/images/logos/snb-nexus-logo.png';
import { guestLoginSchema } from 'src/validations/validation-schemas';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { useFormik } from 'formik';

import { Spinner, Input } from 'reactstrap';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';

import axios from 'axios';

import { useGuestStore } from '../../App';

import { toast } from 'react-toastify';
import IP from '../../sections/variables'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

const GuestLoginPage = () => {

  document.title = 'Login | SNB Nexus 2026'

  // Android scrolls the whole page up when the keyboard opens; iOS Safari doesn't.
  // When the visible area shrinks while the input is focused, scroll the page's bottom into view.
  const wrapperRef = useRef(null)
  useEffect(() => {
    const vv = window.visualViewport
    if (!vv) return
    const lift = () => {
      if (document.activeElement?.id === 'phoneInput') wrapperRef.current?.scrollIntoView({ block: 'end' })
    }
    vv.addEventListener('resize', lift)
    return () => vv.removeEventListener('resize', lift)
  }, [])

  const URL = `${window.location.protocol}//${IP}/api`


  const onSubmit = () => {
    // shared guest access: "2026" skips the API and logs in as a generic "Guest"
    if (values.phone.trim() === '2026') {
      useGuestStore.setState({ userStatus: true, id: null, name: 'Guest', phone: '2026', room: '' })
      navigate('/home')
      return
    }
    signInMutation.mutate(values)
    // navigate('/home')
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema: guestLoginSchema,
    onSubmit,
    enableReinitialize: true,
  })

  let navigate = useNavigate()


  const signIn = (payload) => {

    return axios.post(`${URL}/accounts/guest-login`, payload)
  }

  const signInMutation = useMutation(signIn, {
    onSuccess: (res) => {
      if (res?.data) {
        useGuestStore.setState({ userStatus: true })
        useGuestStore.setState({ id: res?.data?.id })
        useGuestStore.setState({ name: res?.data?.name })
        useGuestStore.setState({ phone: res?.data?.phone })
        useGuestStore.setState({ room: res?.data?.room_number ?? '' })
        navigate('/home')
      }
    },
    onError: () => {
      toast.error('Guest with this phone number not found')
    }
  })

  const handleKeyPress = (e) => {

    if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === '-') {
      e.preventDefault();
    }
    else {
      handleChange(e)
    }
  };

  return (
    <div className='login-wrapper' ref={wrapperRef}>
      <Container maxWidth="sm" className='mt-4 mb-5 login-container'>
        <h1 className='text-white text-bold login-title'>Welcome to</h1>
        <img src={nexusLogo} alt="SNB Nexus - The Next Evolution" className='login-brand' />
        <form className='login-form' onSubmit={handleSubmit}>
          <div className={'d-flex aligin-items-center login-input-wrapper'}>
            <LocalPhoneIcon className='login-input-icon' />
            <Input
              value={values.phone}
              onChange={handleChange}
              onBlur={handleBlur}
              type="text"
              className={"form-control form-control-icon login-field"}
              // className={errors.phone && touched.phone ? "form-control login-field form-control-icon is-invalid col-6" : "form-control form-control-icon login-field col-6"}
              id="phoneInput"
              placeholder="Log in with mobile number"
              name="phone"
              min={0}
            />
          </div>
          {
            errors.phone && touched.phone && <div className="invalid-feedback">{errors.phone}</div>
          }

          <div className='text-center'>
            <button
              style={{ position: "relative" }}
              type="submit"
              className="btn admin-green-btn mt-3 mb-2"
              disabled={signInMutation.isLoading}>
              {signInMutation.isLoading ? "Signing In" : 'Sign in'}
              {signInMutation.isLoading && <Spinner size="sm" className="flex-shrink-0 ms-2" />}
              <ChevronRightRoundedIcon className='login-btn-icon' />
            </button>

          </div>
        </form>
      </Container>
    </div>
  );
}


export default GuestLoginPage;